import { App } from './App';
import { AppConfig } from './AppConfig';

function init()
{
    const app = new App(AppConfig);

    app.run();
}

if (window.cordova)
{
    document.addEventListener('deviceready', () => init());
}
else
{
    init();
}

